import styles from './EmergencyBanner.module.scss'
import { ReactComponent as EmergencyTriangle } from "../../images/global/exclamation-triangle.svg"

const EmergencyBanner = ({ text }) => {
 return (
  <div className={styles.banner} id="emergency-banner">
    <EmergencyTriangle />
    <p id="emergency-banner_text">{text}</p>
  </div>
 )
}

export default EmergencyBanner